// Copyright (C) 2021 Bystronic Laser AG

import {
  CareAlertMetric,
  AlertOperator,
  AlertSeverity,
} from './enums/AlertsEnums';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';

export interface StandardAlert {
  // "Number" in the UI
  id: number;
  status: StandardAlertStatus;
  name: string;
  description: string | null;
  severity: AlertSeverity;
  // KPI
  metric: CareAlertMetric;
  operator: AlertOperator;
  threshold: number;
  dateGrouping: FilterTimeAxisSpanEnum;
  eventSources: string[];
  eventCodes: string[];
  variable: string | undefined;
  deactivationDate: Date | null;
  deactivatedBy: string | null;
  createdBy: string;
  modifiedBy: string;
  modifiedDate: Date;
}

/**
 * Statuses for standard alerts.
 *
 * Depends on the status of its derived preset alerts.
 */
export enum StandardAlertStatus {
  /**
   * No derived preset alerts applied to any device yet.
   *
   * Default status when created. */
  Draft = 1,

  /** Derived preset alert applied to some device but not triggered. */
  Active = 2,

  /** Some derived preset alert has been triggered. */
  InUse = 3,

  /** No longer detecting (soft deletion). */
  Inactive = 4,
}
